import React from 'react';
import { RefreshCw, Trash2 } from 'lucide-react';
import { Button, Card, Section } from '../../components/ui';

export interface SystemSectionProps {
  onAppReload: () => void;
  onClearData: () => void;
}

export const SystemSection: React.FC<SystemSectionProps> = ({ onAppReload, onClearData }) => (
  <Section
    title="System-Tools"
    description="Nutze diese Werkzeuge nur, wenn du Probleme mit der App hast, z. B. veraltete Daten, Ladefehler oder Cache-Probleme."
  >
    <div className="flex flex-col gap-3">
      <Card padding="md" className="flex flex-col items-start gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="font-medium text-ink">App-Reload (PWA)</p>
          <p className="text-sm text-muted">
            Entfernt den Service-Worker und erzwingt ein vollständiges Neuladen aller Dateien vom Server. Hilft bei
            "hängenden" App-Versionen.
          </p>
        </div>
        <Button type="button" variant="secondary" leftIcon={<RefreshCw className="h-4 w-4" aria-hidden="true" />} onClick={onAppReload}>
          App-Reload
        </Button>
      </Card>

      <Card padding="md" className="flex flex-col items-start gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="font-medium text-ink">Daten löschen</p>
          <p className="text-sm text-muted">
            Löscht alle lokalen Daten (Cookies, LocalStorage, IndexedDB) und meldet dich ab. Hilft bei korrupten
            lokalen Zuständen.
          </p>
        </div>
        <Button type="button" variant="danger" leftIcon={<Trash2 className="h-4 w-4" aria-hidden="true" />} onClick={onClearData}>
          Löschen
        </Button>
      </Card>
    </div>

    <p className="mt-4 text-sm text-muted">User-Agent: {navigator.userAgent}</p>
    <p className="text-sm text-muted">LocalStorage: {localStorage.length} Einträge</p>
  </Section>
);
